<template>
    <div class="bg-white shadow-custom overflow-hidden rounded-sm mb-4" data-cy="card_history_redeem_item">
        <div class="grid grid-cols-2">
            <div class="pl-4 pr-3.5 my-4" data-cy="btn_history_redeem_image" @click="clickToDetail()">
                <img class="rounded-lg" data-cy="img_history_redeem_campaign" :src="purchase.fullImageUrl">
            </div>
            <div class="py-4">
                <div class="font-bold text-16 text-a-blue-2140a6 pb-1.5"
                    data-cy="myrewards_campaign_detail_text"
                    :class="[{'text-a-gray-a4a4a4' : isExpired || isUsed}]"
                    @click="clickPurchase()">
                    {{purchase.name}}
                </div>
                <!-- <div class="text-12 text-a-gray-999999 pt-2 pb-4">
                    {{FilterDateTimeFormat(purchase.redeemDate)}}
                </div> -->
                <!-- <div>{{getPointMessage()}}</div> -->
                <div class="text-12 text-a-gray-999999" v-if="(isShowPurchaseMsg && !isShowDelivery)" data-cy="text_myrewards_redeemed_on">
                    <span>{{lbl.purchase.status}}</span>
                    <span :class="[{'text-a-red-ff4d4d' : isExpired, 'text-a-gray-a4a4a4': isUsed}]"
                        v-html="purchaseMessage"
                        v-if="!isActive"></span>
                    <span v-else data-cy="text_myrewards_valid_until">
                        {{lbl.purchase.use_date}} {{FilterDateShortFormat(purchase.voucherExpireDate)}}
                    </span>
                </div>
                <div class="text-12 text-a-gray-999999" v-if="isShowDelivery">
                    <span>{{lbl.purchase.status}}</span>
                    <span :class="[{'text-a-yellow-ffca66' : !isShipped, 'text-a-green-3dcc6d' : isShipped}]">
                        {{deliveryMessage}}
                    </span>
                </div>
                <div class="flex items-center gap-1 text-12 text-a-gray-999999 pt-1 pr-1" v-if="purchase.parcelNo">
                    <div>{{lbl.purchase.parcel_no}} {{purchase.parcelNo}}</div>
                    <div class="z-10"
                        v-clipboard:copy="purchase.parcelNo"
                        v-clipboard:success="onCopyCode">
                        <img class="w-3" src="@/assets/icon/ic-copy.svg" />
                    </div>
                </div>
                <div class="text-12 text-a-gray-999999" v-if="isShowPrivilegeMessage" v-html="privilegeMessage"></div>
                <div class="pt-4" v-if="isActive && !isShowDelivery && !isOnlyShowDetail()" @click="clickPurchase()">
                    <div class="w-11/12 bg-a-blue-2140a6 font-bold text-white text-14 text-center py-2.5 rounded-sm" data-cy="myrewards_view_code_button">
                        {{lbl.purchase.used_coupon}}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Util from '@/helper/Utility.js';
import { CampaignType } from '@/helper/StaticValue.js';
import LocaleMixin from '@/mixin/LocaleMixin.js';
import ModalMixin from '@/mixin/ModalMixin.js';

/**
 * @event onClickPurchase
 */
export default {
    name: 'HistoryItem',
    mixins: [LocaleMixin, ModalMixin],
    props: {
        purchase: { type: Object, required: true },
    },
    data: function() {
        return {
            deliveryMessage: '',
            isActive: false,
            isShipped: false,
            isShowAdsMessage: false,
            isShowDelivery: false,
            isShowPrivilegeMessage: true,
            isWinner: false,
            privilegeMessage: this.purchase.privilegeMessage,
            purchaseMessage: '',
            type: 'purchase', //draw, interface, purchase.

            isExpired: false,
            isUsed: false,
            isStarbuckMigrate: false,
        };
    },
    created: function() {
        this.initialPurchase();
    },
    computed: {
        isShowPurchaseMsg: function() {
            return this.type == 'purchase' || this.type == 'draw' || this.type == 'interface' || this.type == 'verify_code' || this.type == 'interface';
        },
        isSuccess: function(){
            let date = this.FilterDatePlus(this.purchase.redeemDate, 7);
            return (this.FilterDateDiffToday(date, true).days);
        },
    },
    methods: {
        getPointMessage: function () {
            var pointType = this.purchase.pointType == 'get' ? this.lbl.history.get_point : this.lbl.history.use_point;
            var pointUnit = this.lbl.history.point + (this.purchase.pointPerUnit > 1 && this.localeCode == 1033 ? 's' : '');
            return pointType + " " + this.purchase.pointPerUnit + " " + pointUnit;
        },
        initialPurchase: function () {
            if (this.purchase.privilegeMessageFormat && this.purchase.privilegeMessageFormat.toLowerCase() === 'html') {
                this.isShowPrivilegeMessage = false;
            }

            //purchase message.
            switch(this.purchase.type) {
                case CampaignType.Draw:
                    this.isDraw = true;
                    this.type = 'draw';
                    this.purchaseMessage = this.lbl.purchase.not_draw1 + (this.lbl.purchase.not_draw2 ? ' ' + this.lbl.purchase.not_draw2 : '');

                    if (this.purchase.hasWinner) {
                        this.isActive = true;
                        if (this.purchase.isWinner) {
                            this.isWinner = true;
                            this.purchaseMessage = this.lbl.purchase.draw_winner1 + (this.lbl.purchase.draw_winner2 ? ' ' + this.lbl.purchase.draw_winner2 : '');

                            if (this.isShowAdsMessage && this.purchase.adsMessage) {
                                this.purchaseMessage += "<br>" + this.purchase.adsMessage;
                            }
                        } else {
                            this.isWinner = false;
                            this.purchaseMessage = this.lbl.purchase.draw_not_win1 + (this.lbl.purchase.draw_not_win2 ? ' ' + this.lbl.purchase.draw_not_win2 : '');
                        }
                    }

                    this.isShowPrivilegeMessage = false;
                    break;
                case CampaignType.Buy:
                case CampaignType.Free:
                case CampaignType.Deal:
                    if(this.purchase.info2 && (this.purchase.info2.toLowerCase() == 'starbucks' || this.purchase.info2.toLowerCase() == 'startbucks')){
                            if (this.purchase.serial == "XXXXXXX") {
                                this.purchaseMessage = this.lbl.purchase.code_expired;
                                this.isShowPrivilegeMessage = false;
                                this.isExpired = true;
                            } else {
                                this.isShowPrivilegeMessage = false;
                                this.isActive = true;
                            }
                    }else{
                        if (this.isShowUsed() && this.purchase.arrangedDate != null) {
                            this.isUsed = true;
                            this.purchaseMessage = this.lbl.purchase.code_used;
                            this.isShowPrivilegeMessage = false;
                        } else if (this.purchase.serial == "XXXXXXX") {
                            this.purchaseMessage = this.lbl.purchase.code_expired;
                            this.isShowPrivilegeMessage = false;
                            this.isExpired = true;
                        } else {
                            this.isActive = true;
                            this.purchaseMessage = this.lbl.purchase.show_code;
                        }
                    }

                    break;
                case CampaignType.Interface:
                    this.type = 'interface';
                    if (this.purchase.expireIn && this.purchase.expireIn < 0) {
                        this.purchaseMessage = this.lbl.purchase.code_expired;
                        this.isShowPrivilegeMessage = false;
                        this.isExpired = true;
                    } else {
                        this.isActive = true;
                        if (this.purchase.pointType == "get") {
                            this.purchaseMessage = this.lbl.purchase.interface_get;
                        }
                        else {
                            this.purchaseMessage = this.lbl.purchase.interface_use;
                        }
                    }
                    break;
                case CampaignType.VerifyCode:
                    this.type = 'verify_code';
                    this.isShowPrivilegeMessage = false;
                    if(this.isShowUsed() && this.purchase.arrangedDate != null){
                        this.isUsed = true;
                        this.purchaseMessage = this.lbl.purchase.code_used;
                        this.isShowPrivilegeMessage = false;
                        // if (this.purchase.serial == "XXXXXXX") {
                        //     this.purchaseMessage = this.lbl.purchase.code_expired;
                        //     this.isExpired = true;
                        // }else{
                        //     this.purchaseMessage = this.lbl.purchase.code_used;
                        // }

                    }else{
                        if (this.purchase.serial == "XXXXXXX") {
                            this.purchaseMessage = this.lbl.purchase.code_expired;
                            this.isExpired = true;
                        }else{
                            this.isActive = true;
                        }
                    }

                    break;
            }
            //delivery.
            if (this.purchase.delivered === true) {
                this.isShowDelivery = true;
                if (this.purchase.type === CampaignType.Draw) {
                    if (!this.purchase.hasWinner) {
                        this.isShowDelivery = false;
                    } else {
                        if (!this.purchase.isWinner)
                            this.isShowDelivery = false;
                    }
                }

                if (this.purchase.isShipped) {
                    if(this.isSuccess >= 0){
                        this.isShipped = true;
                        this.deliveryMessage = this.lbl.purchase.shipped;
                    }else{
                        this.isShipped = false;
                        this.deliveryMessage = this.lbl.purchase.status_process.delivery;
                    }
                } else {
                    this.isShipped = false;
                    this.deliveryMessage = this.lbl.purchase.status_process.prepare;

                }
            }

            this.deliveryMessage = Util.newLineToBr(this.deliveryMessage);
            this.privilegeMessage = Util.newLineToBr(this.privilegeMessage);
            this.purchaseMessage = Util.newLineToBr(this.purchaseMessage);
        },
        clickToDetail: function() {
            this.$router.push('/campaign/'+this.purchase.id);
        },
        clickPurchase: function() {
            if(this.isOnlyShowDetail()) return;

            this.$emit('onClickPurchase', this.purchase);
        },
        isShowUsed: function(){
            return (this.purchase.privilegeMessage && this.purchase.privilegeMessage.toLowerCase() == 'mark use');
        },
        isOnlyShowDetail: function(){
            if(!this.purchase.website) return;

            return (this.isShopeePay() || this.isTrueMoney() || this.isWondd());
        },
        onCopyCode: function(){
            this.modal.copySuccessModal
                .clearModal()
                .show();
        },
        isShopeePay: function() {
            if (this.purchase.website.indexOf('/shopeepay') >= 0) {
                return true;
            }
            return false;
        },
        isTrueMoney: function() {
            if (this.purchase.website.indexOf('wondd/truemoney') == -1 && this.purchase.website.indexOf('truemoney') >= 0) {
                return true;
            }
            return false;
        },
        isWondd: function() {
            if (this.purchase.website.indexOf('/wondd') >= 0) {
                return true;
            }
            return false;
        }
    }
}
</script>
<style lang="scss" scoped>
</style>
